import { render, staticRenderFns } from "./CaseEdit.vue?vue&type=template&id=025de5c9"
import script from "./CaseEdit.vue?vue&type=script&lang=js"
export * from "./CaseEdit.vue?vue&type=script&lang=js"
import style0 from "./CaseEdit.vue?vue&type=style&index=0&id=025de5c9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports